export const blockIconsPlacesCasino = (
	<span className='material-symbols-outlined'>casino</span>
);
